(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/app/link-navigation/assets/javascripts/linknavigation.js') >= 0) return;  svs.modules.push('/components/app/link-navigation/assets/javascripts/linknavigation.js'); 
(function(Backbone, _, svs) {
  'use strict';

  svs.app.behaviors.LinkNavigation = Marionette.Behavior.extend({
    ui: {
      navigationLink: '.js-navigate',
      navigationBackLink: '.js-navigate-back',
      navigationLinkInstant: '.js-navigate-instant',
      navigationRevealLink: '.js-navigate-reveal',
      navigationLinkWithReturnUrl: '.js-navigate-return-url'
    },

    events: {
      'click @ui.navigationLink': 'navigate',
      'click @ui.navigationBackLink': 'navigateBack',
      'click @ui.navigationLinkInstant': 'navigateImmediately',
      'click @ui.navigationRevealLink': 'navigateReveal',
      'click @ui.navigationLinkWithReturnUrl': 'navigateWithReturnUrl'
    },

    initialize: function() {
      this.router = this.getOption('router');
    },

    doNavigation: function(e, reveal, instant) {
      var dataUrl = e.currentTarget.getAttribute('data-url');
      var index;

      if (e.currentTarget && dataUrl) {
        index = dataUrl.indexOf('/');
        if (index === 0) {
          index = dataUrl.indexOf('/', 1);
        }
        dataUrl = dataUrl.substring(index);
        if (reveal) {
          svs.components.revealAnimation.runRevealAnimation(
            e,
            function() {
              this.router && this.router().navigate(dataUrl, true);
            },
            this
          );
        } else if (svs.components.revealAnimation.isRevertable() && !instant) {
          svs.components.revealAnimation.prepareRevertRevealAnimation(
            function() {
              this.router && this.router().navigate(dataUrl, true);
              svs.components.revealAnimation.revertRevealAnimation();
            },
            this
          );
        } else {
          this.router && this.router().navigate(dataUrl, true);
        }
        e.preventDefault();
        e.stopPropagation();
        return false;
      }
      return true;
    },

    navigateBack: function(e) {
      if (this.getOption('preRendered')) {
        return this.doNavigation(e);
      }
      e.preventDefault();
      e.stopPropagation();
      window.history.back();
    },

    navigateReveal: function(e) {
      return this.doNavigation(e, true);
    },

    navigateImmediately: function(e) {
      return this.doNavigation(e, false, true);
    },

    navigate: function(e) {
      return this.doNavigation(e);
    },

    navigateWithReturnUrl: function(e) {
      svs.utils.form.postToUrl(e.currentTarget.getAttribute('href'), {
        returnUrl: e.currentTarget.getAttribute('data-returnUrl')
      });
      return false;
    }
  });
})(Backbone, _, svs);

 })(window);